// extracted by mini-css-extract-plugin
export default {"svgWrapper":"renderSvg_svgWrapper__-kYH5"};